/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import EasySwipe from 'react-easy-swipe';
import { Modal, Text } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import CloseIcon from '@shared/assets/icons/CloseIcon';
interface ModalBannerProps {
  open: boolean;
  handleClose: (e?: any) => void;
  title?: string;
}
const TooltipMobileText: FC<PropsWithChildren<ModalBannerProps>> = ({
  open,
  handleClose,
  title,
  children
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [swipeDirection, setSwipeDirection] = useState('');
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    setIsClosing(!open);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={handleCloseModal} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>{title}</Heading>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <Text>{children}</Text>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "sbsrusx",
  propsAsIs: true,
  vars: {
    "sbsrusx-0": [_exp2()],
    "sbsrusx-1": [_exp3()],
    "sbsrusx-2": [_exp7(), "px"],
    "sbsrusx-3": [_exp5()],
    "sbsrusx-4": [_exp6(), "px"],
    "sbsrusx-5": [_exp8()],
    "sbsrusx-6": [_exp9()],
    "sbsrusx-7": [_exp0()]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h116us11",
  propsAsIs: false,
  vars: {
    "h116us11-0": [_exp1()],
    "h116us11-1": [_exp10(), "px"],
    "h116us11-2": [_exp11()],
    "h116us11-3": [_exp12(), "px"],
    "h116us11-4": [_exp13()]
  }
}));
export default TooltipMobileText;

require("./TooltipMobileText.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TooltipMobileText.tsx");